import {
  CSSProperties,
  forwardRef,
  ForwardRefRenderFunction,
  MouseEventHandler,
  ReactNode,
} from 'react';

import { ThemeBorderRadius } from 'styled-components';
import { PlacementWithLogical, Tooltip } from '@chakra-ui/react';

import { BadgeType, Container, Wrapper } from './styles';

interface BadgeProps {
  type?: BadgeType;
  target?: string;
  borderRadius?: ThemeBorderRadius;
  style?: CSSProperties;
  tooltip?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
  children: ReactNode;
  isDisabled?: boolean;
  readonly showTooltip?: boolean;
  readonly onMouseLeave?: () => void;
  href?: string;
  tooltipPlacement?: PlacementWithLogical;
}

const BaseBadge: ForwardRefRenderFunction<HTMLDivElement, BadgeProps> = (
  {
    children,
    borderRadius = 'lg',
    type = 'primary',
    tooltip,
    style,
    onClick,
    isDisabled,
    showTooltip = undefined,
    href,
    target,
    tooltipPlacement,
  },
  ref
) => {
  return (
    // @ts-ignore
    <Tooltip
      label={tooltip}
      hasArrow
      closeOnClick={false}
      isOpen={showTooltip}
      closeDelay={0.3}
      placement={tooltipPlacement}
      whiteSpace="pre-wrap"
    >
      <Wrapper style={style} {...(!!href && { as: 'a', href, target })}>
        <Container
          isDisabled={isDisabled}
          borderRadius={borderRadius}
          type={type}
          className="badge"
          href={href}
          ref={ref}
          onClick={onClick}
        >
          <div>{children}</div>
        </Container>
      </Wrapper>
    </Tooltip>
  );
};

export const Badge = forwardRef(BaseBadge);
